
import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

/** Query flag set when navigating from RecommendPlaceModal after publish. */
export const PLACE_SHARE_CTA_QUERY = 'share_cta';
export const PLACE_SHARE_CTA_VALUE = '1';

/** Query flag set when navigating to profile to open UserRecommendationsModal. */
export const PROFILE_OPEN_RECS_QUERY = 'open_recs';
export const PROFILE_OPEN_RECS_VALUE = '1';

/**
 * When the URL contains `?share_cta=1` (after modal publish → /place/[id]),
 * open the published Share flow once the owner editor has a post id, then strip
 * the query param so refresh does not reopen the overlay.
 */
export function usePlacePublishedShareCta(opts: {
  interactionMode: 'owner' | 'readonly' | 'logged-out';
  editingPostId: string | null | undefined;
  openPostPublishShare: () => void;
}): void {
  const { interactionMode, editingPostId, openPostPublishShare } = opts;
  const [searchParams] = useSearchParams();
  const router = useNavigate();
  const pathname = useLocation().pathname;

  useEffect(() => {
    if (interactionMode !== 'owner') return;
    if (searchParams.get(PLACE_SHARE_CTA_QUERY) !== PLACE_SHARE_CTA_VALUE) return;
    if (!editingPostId) return;

    const frame = requestAnimationFrame(() => {
      openPostPublishShare();
      router(pathname, { replace: true });
    });
    return () => cancelAnimationFrame(frame);
  }, [interactionMode, editingPostId, pathname, router, searchParams, openPostPublishShare]);
}
